module.exports = __webpack_public_path__ + "img/footer-car.bf541bd7.png";